// src/components/button/AdminFloatingButton.jsx

import { useLocation } from "react-router-dom";

export default function AdminFloatingButton() {
  const location = useLocation();

  // Wyciągamy nazwę venue z pathname
  // Obsługuje: /nazwa, /nazwa/o-nas, /nazwa/admin, /nazwa/cokolwiek
  const pathParts = location.pathname.split('/').filter(part => part);
  const venueName = pathParts[0] || null;

  // Nie pokazujemy przycisku, jeśli nie jesteśmy na stronie konkretnego venue
  // (np. na /sukces, /prywatnosc, /admin/sync itp.)
  if (!venueName) return null;

  // Opcjonalnie: ukryj przycisk na stronach samego panelu admina (żeby nie dublować)
  if (location.pathname.includes('/admin')) return null;

  const handleOpenAdmin = () => {
    window.open(`/${venueName}/admin`, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      onClick={handleOpenAdmin}
      className="fixed bottom-6 right-6 z-50 bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-4 px-6 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 hover:shadow-3xl flex items-center gap-3 group"
      aria-label="Otwórz panel administracyjny"
    >
      {/* Ikona edycji */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
        />
      </svg>

      <span className="hidden group-hover:inline-block transition-all duration-200 whitespace-nowrap">
        Panel administracyjny
      </span>
    </button>
  );
}